import { Button, Grid } from '@material-ui/core';
import { useState, useImperativeHandle, forwardRef } from 'react';
import { TextFieldSaurus } from 'views/components/controles/inputs';
import { CircularLoading, makeUtilClasses } from 'views';
import {
  DefaultFormRefs,
  DefaultFormProps,
} from '../../utils/form-default-props';
import { picker } from 'utils/picker';
import { Controller, useForm } from 'react-hook-form';
import { TransferirContratoFormModel } from 'model/app/forms/transferir-contrato/transferir-contrato-model';
import { useFormTransferirContratoValidation } from './form-transferir-contrato-validation';
import { yupResolver } from '@hookform/resolvers/yup';

export const FormTransferirContrato = forwardRef<
  DefaultFormRefs<TransferirContratoFormModel>,
  DefaultFormProps<TransferirContratoFormModel>
>(({ loading, ...props }: DefaultFormProps<TransferirContratoFormModel>, ref) => {
  const utilClasses = makeUtilClasses();
  const [modelForm, setModelForm] = useState<TransferirContratoFormModel>(
    new TransferirContratoFormModel(),
  );
  const { FormTransferirContratoValidationYup } = useFormTransferirContratoValidation();

  const {
    handleSubmit,
    control,
    formState: { errors, touchedFields },
    reset,
  } = useForm<TransferirContratoFormModel>({
    defaultValues: { ...modelForm },
    criteriaMode: 'all',
    resolver: yupResolver(FormTransferirContratoValidationYup),
    mode: 'onChange',
  });

  const onSubmit = async (values: TransferirContratoFormModel) => {
    const model = picker<TransferirContratoFormModel>(values, new TransferirContratoFormModel());
    props.onSubmit(model, modelForm);
  };

  useImperativeHandle(ref, () => ({
    submitForm: () => {
      handleSubmit(onSubmit)();
    },
    resetForm: () => {
    },
    fillForm: (model: TransferirContratoFormModel) => {
      setModelForm(model);
      reset({ ...model });
    },
  }));

  return (
    <>
      <div className={utilClasses.formContainer}>
        {loading && props.showLoading ? (
          <CircularLoading tipo="FULLSIZED" />
        ) : null}
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={loading ? utilClasses.controlLoading : ''}
        >
          <Grid container >
            <Grid item xs={12}>
              <Controller
                name="cnpj"
                control={control}
                render={({ field }) => (
                  <TextFieldSaurus
                    tipo="CNPJ"
                    fullWidth
                    allowSubmit={true}
                    disabled={loading}
                    label={'Informe o CNPJ'}
                    variant="outlined"
                    error={Boolean(errors.cnpj && errors.cnpj.message)}
                    helperText={
                      touchedFields.cnpj || errors.cnpj
                        ? errors.cnpj?.message
                        : undefined
                    }
                    {...field}
                  />
                )}
              />
            </Grid>
          </Grid>
          <Button style={{ display: 'none' }} type="submit"></Button>
        </form>
      </div>
    </>
  );
});
